import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import styles from "./AllOrders.module.scss";
import ManageTable from "../../../../views/Manage/ManageTable";
import { Loader } from "react-feather";
import CustomDropdown from "../../../common/Dropdown/CustomDropDown";
import ReadyToShipModal from "./ReadyToShipModal";

const AllOrders = () => {
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const exportOptions = [
    "Export all orders",
    "Export all selected orders",
    "Export all pending orders",
    "Export all ready to ship orders",
    "Export all shipped orders",
    "Export all delivered orders",
    "Export all cancelled orders",
    "Export all returned orders",
    "Export all refund only orders",
    "Export all failed delivery orders",
  ];

  const data = [
    {
      id: 1,
      orderId: "#235435745",
      invoice: "Invoice",
      items: 1,
      orderDate: "08/06/2024",
      updateDate: "08/06/2024",
      price: "$33.33",
      paymentMethod: "COD",
      status: "Pending",
    },
    {
      id: 2,
      orderId: "#235435745",
      invoice: "Invoice",
      items: 1,
      orderDate: "08/06/2024",
      updateDate: "08/06/2024",
      price: "$33.33",
      paymentMethod: "COD",
      status: "Pending",
    },
  ];

  const columns = [
    {
      name: "Order ID",
      selector: (row) => row.orderId,
      sortable: true,
      minWidth: "120px",
    },
    {
      name: "Invoice",
      cell: (row) => row.invoice,
    },
    {
      name: "Items",
      selector: (row) => row.items,
      sortable: true,
    },
    {
      name: "Order date",
      selector: (row) => row.orderDate,
      sortable: true,
      minWidth: "140px",
    },
    {
      name: "Update date",
      selector: (row) => row.updateDate,
      sortable: true,
      minWidth: "140px",
    },
    {
      name: "Price",
      cell: (row) => row.price,
    },
    {
      name: "Payment method",
      selector: (row) => row.paymentMethod,
      minWidth: "140px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
    },
    {
      name: "Action",
      cell: () => (
        <div className="my-1">
          <div
            className={`border border-secondary p-1 rounded ${styles["ready-to-ship"]}`}
            onClick={() => setIsModalOpen(true)}
          >
            Ready to ship
          </div>
          <div className="px-1 mt-1">Cancel</div>
        </div>
      ),
      minWidth: "140px",
    },
  ];

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <div className={styles.container}>
      <ReadyToShipModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />

      <Container fluid className={styles.total}>
        <span className={styles.heading}>Total Orders: 300</span>
        <div className="d-flex align-items-center justify-content-between gap-2">
          <span className={`${styles.dropdown} rounded`}>
            <CustomDropdown title="Export" options={exportOptions} />
          </span>
          <span className={`${styles.dropdown} rounded`}>
            <CustomDropdown
              title="View History"
              options={["Today", "Yesterday", "Last 7 days", "Last month"]}
            />
          </span>
        </div>
      </Container>

      {loading ? (
        <Loader />
      ) : (
        <ManageTable
          name="Pending Orders"
          columns={columns}
          tableData={data}
          isSelectable={true}
        />
      )}
    </div>
  );
};

export default AllOrders;